import axios from 'axios';
import { CMError } from "./cm-error.model";
import Vue from "vue";

Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.ChallengeAPI)
            this.$challengeApi = options.ChallengeAPI;
        else if (options.parent && options.parent.$challengeApi)
            this.$challengeApi = options.parent.$challengeApi;
    }
});

export function makeChallengeAPI(token, conf) {
    return new ChallengeAPI(token, conf);
}

export default class ChallengeAPI {

    constructor(token) {
        this._ax = axios.create({
            baseURL: process.env.VUE_APP_CHALLENGE_API_ENDPOINT,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        });
    }

    async getParticipations() {
        try {
            const res = await this._ax.get(`me/participations`);
            return res.data;
        } catch (error) {
            if (error.response && error.response.status === 404) {
                return '';
            }
            this._handleError(error);
        }
    }

    _handleError(error) {
        if (error.response) {
            if (error.response.status === 401) {
                throw new CMError('Unauthorized', error);
            }
            if (error.response.status === 409) {
                throw new CMError('Conflict', "There is another event with the same data");
            }
            throw new CMError("GenericError", error.response)
        } else if (error.request) {
            throw new Error('Error on request => Server does not respond');
        } else {
            throw new Error('Client error => ' + error.message);
        }
    }
}


// window.cmSsoInitAync = function () {
//     window.CMSSOInstance = new CMSSO({
//         cmtag: ['coding_challenge_cisco','coding_challenge_cisco', 'LOCATION_all', 'language_english'],
//         showThanksMessage: true,
//         thanksMessage: 'THANK YOU!',
//         hop: ' https://extra.codemotion.com/coding-challenge-cisco-thankyou-live/',
//         hopDelay: 3,
//         registerMessage: 'We have sent an email to your address to verify your account. Please check your inbox and follow the instructions.',
//         loginMessage: ''
//     });
//  };
//  (function (d, s, id) {
//     var js, fjs = d.getElementsByTagName(s)[0];
//     if (d.getElementById(id)) {
//         return;
//     }
//     js = d.createElement(s);
//     js.id = id;
//     js.src = "https://www.codemotion.com/static/sdk/sso/js/v0.9.5/cmsso-sdk.min.js?v=1565009350875";
//     fjs.parentNode.insertBefore(js, fjs);
//  }(document, 'script', 'cmsso-jssdk'));